import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@components/@core/Icon';
import { CardType } from '~/services/config';
import { FaIcon } from '../@core/FaIcon';

const ChildFeed = ({ name = '', status = 0, type = 1, disabled = false, dataCy, onClick = () => {} }) => (
    <div className={`c-lfg-feeds ${disabled ? 'disabled' : 'cursor-pointer'}`} data-cy={dataCy} onClick={() => (disabled ? {} : onClick())}>
        <Icon name={status === 3 ? 'fas fa-check-circle' : 'far fa-circle'} size={26} color={status === 3 ? "#969faa" : "#d1d5db"} active={status === 3} />
        <div className="d-flex-1 ms-2">
            <div className="d-flex">
                <FaIcon name={CardType[type].name} color="#676767" size={14} />
                <span className="dsl-m12 text-400 ms-2">{CardType[type].label}</span>
            </div>
            <span className={`dsl-b16 mb-0 text-400${status === 3 && ' text-line-through'}`}>{name}</span>
        </div>
    </div>
);

ChildFeed.propTypes = {
    name: PropTypes.string,
    status: PropTypes.number,
    type: PropTypes.number,
    disabled: PropTypes.bool,
    dataCy: PropTypes.string,
    onClick: PropTypes.func,
};

export default ChildFeed;
